import { FC } from 'app/FunctionalComponent'
import React from 'react'
import { AccountingText } from 'ui/components/common/accounting-text'
import { StackedItem } from 'ui/components/form'
import { t } from 'ui/components/i18n/i18n'
import { IStateComponentExamples } from 'ui/state/sosComponentExamples'
import { Section } from './Section'

export const SectionAccountingText: FC = (props: {
	stateComponentExamples: IStateComponentExamples
}) => {
	return (
		<Section
			title={t('page.componentExamples.accountingText')}
			stateComponentExamples={props.stateComponentExamples}
			name='accountingText'
		>
			<StackedItem label='Accounting Text' hideOptional={true}>
				<AccountingText isRed={true}>Red Text</AccountingText>
				<AccountingText isRed={false}>Not Red Text</AccountingText>
			</StackedItem>
		</Section>
	)
}
